import { Heart } from "lucide-react";
import { useFavorites } from "../lib/favorites";

/**
 * SaveHeart — small circular heart button that toggles the given listing_key
 * in the current user's favorites. Anonymous clicks trigger the login toast.
 *
 * variant: "light" (dark heart on white pill — for photos with dark overlay)
 *          "dark"  (white heart on dark pill — for light backgrounds)
 */
export default function SaveHeart({ listingKey, address, variant = "light", className = "" }) {
  const { isSaved, toggle } = useFavorites();
  const saved = isSaved(listingKey);

  const base =
    "w-9 h-9 rounded-full flex items-center justify-center transition-all shadow-sm backdrop-blur";
  const styles =
    variant === "light"
      ? "bg-white/95 hover:bg-white text-[#1A1A1A]"
      : "bg-black/60 hover:bg-black/80 text-white";

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(listingKey, { address });
      }}
      className={`${base} ${styles} ${className}`}
      aria-label={saved ? "Remove from saved listings" : "Save this listing"}
      data-testid={`save-heart-${listingKey}`}
      data-saved={saved ? "true" : "false"}
    >
      <Heart
        className={`w-4 h-4 transition-transform ${saved ? "scale-110" : "hover:scale-110"}`}
        strokeWidth={1.75}
        fill={saved ? "#E63946" : "none"}
        stroke={saved ? "#E63946" : "currentColor"}
      />
    </button>
  );
}
